import { getBaseCiRequestUrl, getToken } from '@/utils/constants'
import { httpRequest } from '@/utils/HttpRequest'
import { IPage } from '@/types/AppTypes'
import {
    IFieldSetupColumnUpdate, IFieldSetupColumnInsert, IFieldSetupColumnDetail
} from "./FieldSetTypes";

class FieldSetService {

    async page(searchVo: any) {
        const apiUrl = '/yh-franchisee/fieldConfiguration/list'
        return await httpRequest.post<IPage<IFieldSetupColumnDetail>>(apiUrl, searchVo, { baseURL: getBaseCiRequestUrl(), token: getToken() });
    }
    async one(id: string) {
        const apiUrl = `/yh-franchisee/fieldConfiguration/one/${id}`;
        return await httpRequest.get<IFieldSetupColumnDetail>(apiUrl, { baseURL: getBaseCiRequestUrl(), token: getToken() });
    }
    async insert(insertVo: IFieldSetupColumnInsert) {
        const apiUrl = '/yh-franchisee/fieldConfiguration/insert'
        return await httpRequest.post<IFieldSetupColumnInsert>(apiUrl, insertVo, { baseURL: getBaseCiRequestUrl(), token: getToken() });
    }
    async insertBatch(insertVo: IFieldSetupColumnInsert[]) {
        const apiUrl = '/yh-franchisee/fieldConfiguration/insertBatch'
        return await httpRequest.post<IFieldSetupColumnInsert[]>(apiUrl, insertVo, { baseURL: getBaseCiRequestUrl(), token: getToken() });
    }
    async update(updateVo: IFieldSetupColumnUpdate) {
        const apiUrl = '/yh-franchisee/fieldConfiguration/update'
        return await httpRequest.post<boolean>(apiUrl, updateVo, { baseURL: getBaseCiRequestUrl(), token: getToken() });
    }
    async delete(id: string) {
        const apiUrl = `/yh-franchisee/fieldConfiguration/delete/${id}`
        return await httpRequest.get<boolean>(apiUrl, { baseURL: getBaseCiRequestUrl(), token: getToken() });
    }
}

export const fieldSetService = new FieldSetService();
